import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';

import { Cost, ServiceCostRequestDTO } from '../types';
import Utils from '@/utils/util';

export const getServiceCost = ({ data, serviceType }: ServiceCostRequestDTO): Promise<Cost> => {
  return axios.post(
    serviceType === Utils.SERVICE_TYPES.DAY_CARE ? `parent/daycare/cost` : `parent/boarding/cost`,
    data
  );
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof getServiceCost>;
};

export const useGetServiceCost = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getServiceCost,
  });
};
